import { render } from "./CurrentWinner.vue?vue&type=template&id=75985900&scoped=true"
import script from "./CurrentWinner.vue?vue&type=script&lang=js"
export * from "./CurrentWinner.vue?vue&type=script&lang=js"

import "./CurrentWinner.vue?vue&type=style&index=0&id=75985900&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75985900"]])

export default __exports__